import { useContext, useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { object } from 'prop-types'
import { CvsAutoComplete } from '@components'
import { connectorContext } from '@contexts'
import { templateCopyContext } from '../context'

const FullWidth = styled.div`
  width: 100%;
`

export const GoogleDCMOutput = ({ assignment }) => {
  const { template, onChange } = useContext(templateCopyContext)
  const { byId } = useContext(connectorContext)

  const fieldOptions = useMemo(
    () =>
      Object.values(template.templateFieldsById).map(field => ({
        label: field.field.name,
        value: field.field.id,
      })),
    [template],
  )

  const connectors = useMemo(
    () =>
      Object.values(byId)
        .filter(
          connector =>
            connector.connector_type_id ===
            (assignment.connector_type_id
              ? assignment.connector_type_id
              : byId[assignment.connector_id].connector_type_id),
        )
        .map(({ name, id }) => ({
          label: name,
          value: id,
        })),
    [assignment, byId],
  )

  const onGoogleDCMOutputChange = useCallback(
    (value, name) => {
      onChange(old => ({
        ...old,
        [assignment.id]: {
          ...old[assignment.id],
          [name]: value,
        },
      }))
    },
    [assignment, onChange],
  )

  const onGoogleDCMOutputMetadataChange = useCallback(
    (value, name) => {
      onChange(old => ({
        ...old,
        [assignment.id]: {
          ...old[assignment.id],
          metadata: {
            ...old[assignment.id].metadata,
            [name]: value,
          },
        },
      }))
    },
    [onChange, assignment],
  )

  return (
    <FullWidth>
      <CvsAutoComplete
        options={connectors}
        onSelected={selected => onGoogleDCMOutputChange(selected, 'connector_id')}
        selected={assignment.connector_id}
        label={t`CM360 account`}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(assignment.metadata.updateClickThroughUrl)}
            onChange={() =>
              onGoogleDCMOutputMetadataChange(
                !assignment.metadata.updateClickThroughUrl ? 1 : 0,
                'updateClickThroughUrl',
              )
            }
            color="secondary"
          />
        }
        label={t`Update clickThroughUrl in Google Campaign Manager`}
      />
      <CvsAutoComplete
        label={t`Creative CreativeAssignment.customClickThroughURl`}
        options={fieldOptions}
        selected={assignment.metadata.dcmLink}
        onSelected={val => onGoogleDCMOutputMetadataChange(val, 'dcmLink')}
      />
      <CvsAutoComplete
        onSelected={val => onGoogleDCMOutputMetadataChange(val, 'dcmAdId')}
        selected={assignment.metadata.dcmAdId}
        label={t`Ad ID`}
        options={fieldOptions}
      />
      <CvsAutoComplete
        onSelected={val => onGoogleDCMOutputMetadataChange(val, 'dcmCreativeId')}
        selected={assignment.metadata.dcmCreativeId}
        label={t`Creative ID`}
        options={fieldOptions}
      />
    </FullWidth>
  )
}

GoogleDCMOutput.propTypes = {
  assignment: object.isRequired,
}
